import { trpc } from '@/shared/api';

/** 최신 조회는 초안이나 편집 기준 시각을 바꾸지 않는다. */
export const usePortfolioDetailQuery = (id?: string, enabled = true) => {
  const utils = trpc.useUtils();
  const query = trpc.portfolioManagement.items.get.useQuery(
    { id: id ?? '00000000-0000-4000-8000-000000000000' },
    { enabled: enabled && Boolean(id), refetchOnWindowFocus: false },
  );
  return {
    ...query,
    fetchLatest: () => {
      if (!id) return Promise.reject(new Error('조회할 사례가 없습니다.'));
      return utils.portfolioManagement.items.get.fetch({ id }, { staleTime: 0 });
    },
    resolveCreate: (createToken: string) => {
      if (!id) return Promise.reject(new Error('확인할 등록 ID가 없습니다.'));
      return utils.portfolioManagement.items.resolveCreate.fetch(
        { id, createToken },
        { staleTime: 0 },
      );
    },
  };
};
